'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _compact3 = require('lodash/compact');

var _compact4 = _interopRequireDefault(_compact3);

exports.toUnderscore = toUnderscore;
exports.toUpperUnderscore = toUpperUnderscore;
exports.capitalize = capitalize;
exports.concat = concat;
exports.cleanString = cleanString;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toUnderscore(str) {
  return str.replace(/([A-Z])/g, function ($1) {
    return '_' + $1;
  });
}

function toUpperUnderscore(str) {
  return toUnderscore(str).toUpperCase();
}

function capitalize(str) {
  return str.replace(/\b\w/g, function (matchStr) {
    return matchStr.toUpperCase();
  });
}

function concat(delim) {
  for (var _len = arguments.length, strs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    strs[_key - 1] = arguments[_key];
  }

  return (0, _compact4.default)(strs).join(delim).trim();
}

function cleanString(str) {
  return ('' + str).trim().toLowerCase();
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/strings.js
// module id = 59
// module chunks = 1